
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"39","height":"39","x":".5","y":".5","stroke":"#D5D8E5","rx":"5.5"}}),_c('path',{attrs:{"stroke":"#8689A4","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5","d":"M16.357 18.558l3.177 3.175 6.736-6.737"}}),_c('path',{attrs:{"stroke":"#8689A4","d":"M20 28a8 8 0 010-16m8 8a8 8 0 01-8 8"}})])
          )
        }
      }
    